<div class=" grow flex-column center gap-l">
    
        <mat-spinner [diameter]="size === 'large' ? 64  : 32"></mat-spinner>
        <ng-content></ng-content>
        <div class=" mat-body-2">{{message}}</div>
    
</div>